import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EMBEDDINGS_LOADING, EMBEDDINGS_LOADED, EMBEDDINGS_ERROR } from 'redux/actionTypes/embeddings';
import fetchWork from 'utils/work/fetchWork';
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import parseEmbeddingQuadtree from 'utils/embeddingQuadtree';
import inMemoryDownloader from 'utils/work/downloaders/inMemoryDownloader';
var loadEmbedding = function loadEmbedding(experimentId, embeddingType) {
  var forceReload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState$embeddings$, _getState$embeddings$2, _getState$experimentS;
      var embeddingState, methodSettings, useSaved, body, timeout, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!forceReload && ((_getState$embeddings$ = getState().embeddings[embeddingType]) !== null && _getState$embeddings$ !== void 0 && _getState$embeddings$.loading || (_getState$embeddings$2 = getState().embeddings[embeddingType]) !== null && _getState$embeddings$2 !== void 0 && (_getState$embeddings$2 = _getState$embeddings$2.data) !== null && _getState$embeddings$2 !== void 0 && _getState$embeddings$2.cellIds))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            // Does not load anything if experiment settings is not loaded
            embeddingState = (_getState$experimentS = getState().experimentSettings) === null || _getState$experimentS === void 0 || (_getState$experimentS = _getState$experimentS.processing) === null || _getState$experimentS === void 0 || (_getState$experimentS = _getState$experimentS.configureEmbedding) === null || _getState$experimentS === void 0 ? void 0 : _getState$experimentS.embeddingSettings;
            if (embeddingState) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", null);
          case 5:
            methodSettings = embeddingState.methodSettings, useSaved = embeddingState.useSaved;
            dispatch({
              type: EMBEDDINGS_LOADING,
              payload: {
                embeddingType: embeddingType
              }
            });
            body = {
              name: 'GetEmbedding',
              type: embeddingType,
              useSaved: useSaved,
              config: methodSettings[embeddingType]
            };
            timeout = getTimeoutForWorkerTask(getState(), 'GetEmbedding');
            _context.prev = 9;
            _context.next = 12;
            return fetchWork(experimentId, body, getState, dispatch, {
              timeout: timeout
            }, inMemoryDownloader,
            // arg 6 — explicit: the parser is positional arg 7
            parseEmbeddingQuadtree // arg 7 — runs inside downloadFromS3 / the socket path
            );
          case 12:
            data = _context.sent;
            if (data) {
              _context.next = 15;
              break;
            }
            throw new Error('Embedding result unavailable');
          case 15:
            return _context.abrupt("return", dispatch({
              type: EMBEDDINGS_LOADED,
              payload: {
                experimentId: experimentId,
                embeddingType: embeddingType,
                data: data
              }
            }));
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", dispatch({
              type: EMBEDDINGS_ERROR,
              payload: {
                experimentId: experimentId,
                embeddingType: embeddingType,
                error: _context.t0
              }
            }));
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 18]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadEmbedding;